import { render } from "./ControlBar.vue?vue&type=template&id=5ead1046&scoped=true"
import script from "./ControlBar.vue?vue&type=script&lang=js"
export * from "./ControlBar.vue?vue&type=script&lang=js"

import "./ControlBar.vue?vue&type=style&index=0&id=5ead1046&scoped=true&lang=css"

import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ead1046"]])

export default __exports__